import React from 'react';

const PerformanceMetrics = ({ rating, acceptanceRate, completionRate }) => {
  const metrics = [
    {
      label: 'Driver Rating',
      value: rating || 4.8,
      display: `${rating || 4.8}`,
      suffix: '/ 5.0',
      percentage: ((rating || 4.8) / 5) * 100,
      color: '#ffd700',
      icon: '⭐',
    },
    {
      label: 'Acceptance Rate',
      value: acceptanceRate || 87,
      display: `${acceptanceRate || 87}%`,
      suffix: null,
      percentage: acceptanceRate || 87,
      color: '#34d399',
      icon: '✅',
    },
    {
      label: 'Completion Rate',
      value: completionRate || 96,
      display: `${completionRate || 96}%`,
      suffix: null,
      percentage: completionRate || 96,
      color: '#60a5fa',
      icon: '🏁',
    },
  ];

  return (
    <div className="rounded-2xl bg-[#0f2040] border border-white/8 p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="heading-3 text-white">Performance</h3>
        <span className="caption-text text-white/30">Last 30 days</span>
      </div>
      <div className="space-y-3.5">
        {metrics?.map(metric => (
          <div key={metric?.label}>
            <div className="flex items-center justify-between mb-1.5">
              <div className="flex items-center gap-1.5">
                <span className="text-sm">{metric?.icon}</span>
                <span className="body-text text-white/60">{metric?.label}</span>
              </div>
              <div className="flex items-baseline gap-1">
                <span className="text-white font-bold text-sm">{metric?.display}</span>
                {metric?.suffix && <span className="text-white/30 text-xs">{metric?.suffix}</span>}
              </div>
            </div>
            <div className="h-1.5 bg-white/8 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-700"
                style={{ width: `${metric?.percentage}%`, backgroundColor: metric?.color }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerformanceMetrics;
